import {stringify} from 'qs'
import request from 'message-control/utils/request'
import api from 'message-control/common/api/message-monitor'

export async function sessions(payload) {
    return request(`${api.sessions.url}?${stringify(payload.params)}`, {
        method: api.sessions.type,
        body: payload.body,
    })
}

export async function groupSessions(payload) {
    return request(`${api.groupSessions.url}?${stringify(payload.params)}`)
}

export async function exportMessage(params) {
    return request(`${api.exportMessage.url}?${stringify(params)}`, null, {
        returnResponse: true,
    })
}
